export default __webpack_public_path__ + "static/media/external-playlists.955a8415.svg";